import * as React from 'react';
import { EventFunc } from 'types/types';
import './IconButton.pcss';
import {handleSpacePressed} from "utils";

// #bfbfbf

// more_vert
export const IconButton = (props: {
  onClick?:EventFunc,
  children:any,
  big?:boolean,
  className?:string,
  disabled?:boolean,
  style?:any,
  label?:string,
}) =>
  <a role="button"
     aria-label={props.label}
     tabIndex={0}
     className={`iconBtn noselect${props.big?' big':''} ripple ${props.className?props.className:''}${props.disabled?' disabled':''}`}
     onClick={(e)=>{ if(!props.disabled && props.onClick) { props.onClick(e); } }}
     onKeyDown={(e)=>{ handleSpacePressed(e, ()=>{ if(!props.disabled && props.onClick) { props.onClick(e); }} ) }}
     style={props.style}
  ><i className="material-icons">{props.children}</i></a>
;
